import { css } from '@emotion/css';

// useBottomSheetEffect에서 classList로 토글하는 상태 클래스
export const hide = 'hide';
export const none = 'none';

export const backdrop = css`
    background-color: rgba(33, 33, 33, 0.75);
    display: flex;
    flex-direction: column;
    height: 100vh;
    justify-content: flex-end;
    left: 0;
    position: fixed;
    top: 0;
    transition: 250ms ease-in-out;
    width: 100vw;
    z-index: 9999;

    &.${hide} {
        opacity: 0;

        > div {
            transform: translateY(100%);
        }
    }

    &.${none} {
        display: none;
    }
`;
